// utils
import axios from '../../utils/axios';

const getAllPartnersOfUser = async () => {
  try {
    const response = await axios({
      method: 'get',
      url: `/users/partners`,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getAllPartnersOfUser };
